import burger_32 from "@images/bustle_bs/black_32px/Burger.png";
import coffee_32 from "@images/bustle_bs/black_32px/Coffee.png";
import croissant_32 from "@images/bustle_bs/black_32px/Croissant.png";
import cutlery_32 from "@images/bustle_bs/black_32px/Cutlery.png";
import egg_32 from "@images/bustle_bs/black_32px/Egg.png";
import hotdog_32 from "@images/bustle_bs/black_32px/Hot dog.png";
import iceblock_32 from "@images/bustle_bs/black_32px/Ice Block.png";
import icecream_32 from "@images/bustle_bs/black_32px/Ice Cream.png";
import milk_32 from "@images/bustle_bs/black_32px/Milk.png";
import muffin_32 from "@images/bustle_bs/black_32px/Muffin.png";
import pizza_32 from "@images/bustle_bs/black_32px/Pizza.png";
import salt_32 from "@images/bustle_bs/black_32px/Salt.png";
import taco_32 from "@images/bustle_bs/black_32px/Taco.png";
import burger_96 from "@images/bustle_bs/black_96px/Burger.png";
import coffee_96 from "@images/bustle_bs/black_96px/Coffee.png";
import croissant_96 from "@images/bustle_bs/black_96px/Croissant.png";
import cutlery_96 from "@images/bustle_bs/black_96px/Cutlery.png";
import egg_96 from "@images/bustle_bs/black_96px/Egg.png";
import hotdog_96 from "@images/bustle_bs/black_96px/Hot dog.png";
import iceblock_96 from "@images/bustle_bs/black_96px/Ice Block.png";
import icecream_96 from "@images/bustle_bs/black_96px/Ice Cream.png";
import milk_96 from "@images/bustle_bs/black_96px/Milk.png";
import muffin_96 from "@images/bustle_bs/black_96px/Muffin.png";
import pizza_96 from "@images/bustle_bs/black_96px/Pizza.png";
import salt_96 from "@images/bustle_bs/black_96px/Salt.png";
import taco_96 from "@images/bustle_bs/black_96px/Taco.png";
import * as z from "zod";

import { Customer } from "./schema";

export type bustleBeeKey = (typeof BustleBeeKeys)[number];
export const BustleBeeKeys = [
  "burger",
  "coffee",
  "croissant",
  "cutlery",
  "egg",
  "hotdog",
  "iceblock",
  "icecream",
  "milk",
  "muffin",
  "pizza",
  "salt",
  // "taco",
] as const;

export const BustleBeeKeySchema = z.enum(BustleBeeKeys);

export type BustleBee = {
  img_32: string;
  img_96: string;
  alt: string;
  value: string;
};

type bustleBees = {
  [key in bustleBeeKey]: BustleBee;
};

export const BustleBees: bustleBees = {
  burger: {
    img_32: burger_32,
    img_96: burger_96,
    alt: "Burger",
    value: "burger",
  },
  coffee: {
    img_32: coffee_32,
    img_96: coffee_96,
    alt: "Coffee",
    value: "coffee",
  },
  croissant: {
    img_32: croissant_32,
    img_96: croissant_96,
    alt: "Croissant",
    value: "croissant",
  },
  cutlery: {
    img_32: cutlery_32,
    img_96: cutlery_96,
    alt: "Cutlery",
    value: "cutlery",
  },
  egg: { img_32: egg_32, img_96: egg_96, alt: "Egg", value: "egg" },
  hotdog: {
    img_32: hotdog_32,
    img_96: hotdog_96,
    alt: "Hotdog",
    value: "hotdog",
  },
  iceblock: {
    img_32: iceblock_32,
    img_96: iceblock_96,
    alt: "Iceblock",
    value: "iceblock",
  },
  icecream: {
    img_32: icecream_32,
    img_96: icecream_96,
    alt: "Icecream",
    value: "icecream",
  },
  milk: { img_32: milk_32, img_96: milk_96, alt: "Milk", value: "milk" },
  muffin: {
    img_32: muffin_32,
    img_96: muffin_96,
    alt: "Muffin",
    value: "muffin",
  },
  pizza: { img_32: pizza_32, img_96: pizza_96, alt: "Pizza", value: "pizza" },
  salt: { img_32: salt_32, img_96: salt_96, alt: "Salt", value: "salt" },
  // taco: { img_32: taco_32, alt: "Taco", value: "taco" },
  // coffee: { img_32: coffee_32, alt: "Coffee", value: "coffee" },
  // croissant: { img_32: croissant_32, alt: "Croissant", value: "croissant" },
  // cutlery: { img_32: cutlery_32, alt: "Cutlery", value: "cutlery" },
  // egg: { img_32: egg_32, alt: "Egg", value: "egg" },
  // hotdog: { img_32: hotdog_32, alt: "Hotdog", value: "hotdog" },
  // iceblock: { img_32: iceblock_32, alt: "Iceblock", value: "iceblock" },
  // icecream: { img_32: icecream_32, alt: "Icecream", value: "icecream" },
  // milk: { img_32: milk_32, alt: "Milk", value: "milk" },
  // muffin: { img_32: muffin_32, alt: "Muffin", value: "muffin" },
  // pizza: { img_32: pizza_32, alt: "Pizza", value: "pizza" },
  // salt: { img_32: salt_32, alt: "Salt", value: "salt" },
  // taco: { img: taco_32, alt: "Taco", value: "taco" },
};

export const bustleBeeForCustomer = (customer: Customer) => {
  console.log("customer", customer);
  return customer.icon ? BustleBees[customer.icon] : null;
};
export const BustleBeeList = BustleBeeKeys.map((key) => BustleBees[key]);
